import { render, staticRenderFns } from "./ManagerProfile.vue?vue&type=template&id=12c025a4"
import script from "./ManagerProfile.vue?vue&type=script&lang=ts"
export * from "./ManagerProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c025a4')) {
      api.createRecord('12c025a4', component.options)
    } else {
      api.reload('12c025a4', component.options)
    }
    module.hot.accept("./ManagerProfile.vue?vue&type=template&id=12c025a4", function () {
      api.rerender('12c025a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/roles/ManagerProfile.vue"
export default component.exports